<template>
  <div>
    <h3 class="mb-0">
      Avisos del checador
    </h3>
    <hr class="w-100 my-3" />
    <form @submit.prevent="add()">
      <base-text-area
        v-model="newAnnouncement"
        @keydown.enter.prevent
        placeholder="Escribe un aviso breve"
        inputClasses="input-group-alternative form-control-sm text-xs"
        class="mb-0"
        rows="3"
        noResize
        maxlength="200"
      />
      <div class="d-flex justify-content-between align-items-start mt-2">
        <div class="text-xs text-muted">
          {{ newAnnouncement ? newAnnouncement.length : 0 }}/200
        </div>
        <div
          v-b-popover.hover="
            announcements && announcements.length >= 3 &&
            'Solo se permite un máximo de 3 avisos en el checador'
          "
        >
          <base-button
            icon="fa fa-check"
            type="success"
            size="sm"
            nativeType="submit"
            class="flex-shrink-0"
            :disabled="!valid"
          >
            Agregar
          </base-button>
        </div>
      </div>
    </form>
    <hr class="w-100 my-3" />
    <div v-if="announcements && announcements.length > 0">
      <div
        v-for="(a, index) in announcements"
        :key="index"
        class="shadow-sm border rounded mb-2 p-3 text-xs d-flex align-items-center"
      >
        <span class="flex-grow-1" style="word-break: break-all; ">
          {{ a }}
        </span>
        <base-button
          @click="remove(index)"
          class="flex-shrink-0 ml-3"
          nativeType="button"
          icon="fa fa-trash"
          type="danger"
          size="sm"
          outline
          rounded
          iconOnly
        />
      </div>
    </div>
    <div v-else class="my-5">
      <BaseLoader v-if="!announcements" />
      <EmptySection v-else text="No hay avisos mostrandose en el checador" />
    </div>
  </div>
</template>

<script>
import EmptySection from "@/components/EmptySection.vue";
import BaseLoader from "@/components/BaseLoader.vue";
import { getDatabase, ref, set, onValue } from "firebase/database";
export default {
  name: "Announcements",
  components: {
    EmptySection,
    BaseLoader,
  },
  data() {
    return {
      newAnnouncement: null,
      announcements: null,
    };
  },
  methods: {
    add() {
      if (this.valid) {
        this.announcements.push(this.newAnnouncement);
        this.newAnnouncement = null;
        const db = getDatabase();
        set(ref(db, "checker_announcements"), this.announcements);
      }
    },
    remove(index) {
      this.announcements.splice(index, 1);
      const db = getDatabase();
      set(ref(db, "checker_announcements"), this.announcements);
    },
  },
  created() {
    const db = getDatabase();
    const announcementsRef = ref(db, "checker_announcements");
    try {
      onValue(announcementsRef, (snapshot) => {
        if (snapshot && snapshot.size > 0) {
          this.announcements = snapshot.val();
        } else {
          this.announcements = [];
        }
      });
    } catch (err) {
      console.error(err);
    }
  },
  computed: {
    valid() {
      return (
        this.newAnnouncement &&
        (!this.announcements || this.announcements.length < 3)
      );
    },
  },
};
</script>

<style lang="scss" scoped></style>
